// ─────────────────────────────────────────────
//  Nav — top navigation for public marketing pages
// ─────────────────────────────────────────────

export default function Nav({ onHome, onHow, onPricing, onGetStarted }) {
  return (
    <nav style={{
      position: "sticky", top: 0, zIndex: 100,
      background: "rgba(10,10,15,0.88)",
      backdropFilter: "blur(20px)",
      borderBottom: "1px solid rgba(255,255,255,0.07)",
      padding: "0 40px",
      display: "flex", alignItems: "center", justifyContent: "space-between",
      height: 60,
    }}>
      {/* Logo */}
      <button onClick={onHome} style={{ display:"flex", alignItems:"center", gap:10, background:"none", border:"none", cursor:"pointer", color:"white", fontFamily:"inherit" }}>
        <div style={{ width:32, height:32, borderRadius:9, background:"linear-gradient(135deg,#FF6B35,#FFBE0B)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:17 }}>⚡</div>
        <span style={{ fontWeight:900, fontSize:17, letterSpacing:"-0.04em" }}>JiffyReview</span>
      </button>

      {/* Links */}
      <div style={{ display:"flex", gap:28, alignItems:"center" }}>
        <button onClick={onHow} style={{ background:"none", border:"none", color:"rgba(255,255,255,0.5)", fontSize:14, cursor:"pointer", fontFamily:"inherit", fontWeight:500 }}>How it works</button>
        <button onClick={onPricing} style={{ background:"none", border:"none", color:"rgba(255,255,255,0.5)", fontSize:14, cursor:"pointer", fontFamily:"inherit", fontWeight:500 }}>Pricing</button>
        <button onClick={onGetStarted} style={{ padding:"9px 20px", borderRadius:10, border:"none", background:"linear-gradient(135deg,#FF6B35,#FFBE0B)", color:"white", fontSize:14, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>
          Get Started Free →
        </button>
      </div>
    </nav>
  );
}
